import RadioButtonUncheckedOutlined from "@mui/icons-material/RadioButtonUncheckedOutlined";

import { makeSvgIcon } from "./svg-icon";

export const InProgressIcon = makeSvgIcon(
  RadioButtonUncheckedOutlined,
  (theme) => theme.palette.warning.main
);

export default InProgressIcon;
